import { baseQuery } from '../baseQuery';

export const getCallScripts = async () => {
  const { data } = await baseQuery('call-scripts');

  return data;
};
